import React, { Component } from 'react';
import { connect } from 'react-redux';
import PageTemplate from '../../components/template/PageTemplate';
import { HOME_TYPE, WIDGET_PAGE_NAME } from '../../constants/service/app/widgetConstants';
import PageWidgetListContainer from '../../containers/widget/HomeWidgetListContainer';
import { widgetActions } from '../../store/modules/widget';

class MainPageWidgetList extends Component {
  componentDidMount() {
    this.initiate();
  }

  /**
   * 초기 데이터 불러오기
   */
  initiate = () => {
    this.getList();
  };

  /**
   *  페이지 위젯 리스트 불러오기
   */
  getList = () => {
    const { getMainPageWidgetList } = this.props;

    getMainPageWidgetList();
  };

  render() {
    return (
      <PageTemplate pageName={WIDGET_PAGE_NAME.MAIN_PAGE_MANAGEMENT}>
        <PageWidgetListContainer homeType={HOME_TYPE.MAIN} getList={this.getList} />
      </PageTemplate>
    );
  }
}

const mapDispatchToProps = {
  getMainPageWidgetList: widgetActions.getMainPageWidgetList,
};

export default connect(null, mapDispatchToProps)(MainPageWidgetList);
